export const css = {
    root: '_3gYYteZN',
    buffer: '_1hCUf_Oj',
    bar: 'yol4inw-',
    primary: 'MvGT-igZ',
    progress: '_3Gx12-Ut',
    inner: '_2k0ojoHY',
    ' _key': 'apic-theme/dojo/loading-indicator'
};
export default css;
